<template>
  <div>
      <b-navbar :class="{'navbar-mobile':$uiHelpers.isMobile }" class="navbar position-absolute">
        <b-navbar-brand><img class ="navbar-brand-img" :style="getLogoStyles" :src="getLogo"/></b-navbar-brand>
        <b-navbar-nav  class="outside-collapse">
          <lang-selector :enablePortuguese="true" :class="{'flex-mobile-lang':$uiHelpers.isMobile, 'mr-4':!$uiHelpers.isMobile }"></lang-selector>
          <b-nav-item class="my-auto d-none d-lg-block">
            <base-button blue @click="goToContactForm"><span>{{ $t('more-info-btn') }}</span> <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="ml-2" color="white"/></base-button>               
          </b-nav-item>   
        </b-navbar-nav>
      </b-navbar>
    
      <div class="landing-cnt row">
        <div class="bg-img"></div>
        <div class="main-block col">
          <h3>{{ $t('main-block-h1') }}</h3>
          <div class="btn-cnt">
              <!-- <base-button white shadow :href="$helpers.get360AppUrl()">{{ $t('login.sign-in') }}</base-button> -->
              <base-button outline blue @click="goToContactForm">{{ $t('more-info-btn') }}</base-button>
          </div>
        </div>
        <div class="learn-more" @click="goToContactForm">
          <span>{{ $t('learn-more-btn') }}</span>
        </div>
      </div>

<b-row id="section-cero" class="section py-lg-5 py-0">
        <b-col class="my-auto content center-text" cols="12">
          <b-row>
            <b-col class="pr-lg-5 pr-sm-0" sm="12" lg="6">
              <div class="subtitle">
                <p>{{ $t('section-cero.subtitle') }}</p>
                                <base-button @click="goToMedicPsico" outline shadow class="mt-2 mb-5 btn-all">{{ $t('section-cero.medicpsico') }}</base-button>
              </div>
            </b-col>
             <b-col class="pr-lg-5 pr-sm-0" sm="12" lg="6">
              <div class="subtitle">
                <p>{{ $t('section-cero.subtitle-2') }}</p>
                                <base-button @click="goToContactForm" outline shadow class="mt-2 mb-5 btn-all btn-ong">{{ $t('section-cero.ong') }}</base-button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="$uiHelpers.isMobile" style="min-height:50vh !important" id="section-super-doctor-mobile" class="section py-lg-5 py-0">
        <b-col style="max-height:50%;height:50%">
          <div class="col-bg ml-lg-auto"> 
          </div>
        </b-col>
      </b-row>
      
      <b-row id="section-one" class="section py-lg-5 py-0">
        <b-col md="12" lg="6" class="my-auto content">
          <h3>{{ $t('section-one.title') }}</h3>
          <div class="subtitle">
            <p>{{ $t('section-one.subtitle') }}</p>
          </div>
          <br>
          <base-button @click="goToContactForm" outline shadow class="mt-5 btn-center">{{ $t('more-info') }}</base-button>
        </b-col>
        <b-col md="12" lg="6" class="py-sm-0 py-lg-5">
          <div class="col-bg ml-lg-auto"> 
          </div>
        </b-col>
      </b-row>
      
      <b-row id="section-two" class="section-invert reverse-sm">
        <b-col md="12" lg="6">
          <div class="col-bg ml-lg-auto">
          </div>
        </b-col>
        <b-col md="12" lg="6" class="content my-auto">
          <h3>{{ $t('section-two.title') }}</h3>
          <div class="subtitle">
            <div class="subtitle-list mt-5">
              <b-row>
                <b-col cols="1">
                  <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
                </b-col>
                <b-col cols="10" offset-sm="1">
                  <span>
                    {{ $t('section-two.list.1') }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1">
                  <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
                </b-col>
                <b-col cols="10" offset-sm="1">
                  <span>
                    {{ $t('section-two.list.2') }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1">
                  <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
                </b-col>
                <b-col cols="10" offset-sm="1">
                  <span>
                    {{ $t('section-two.list.3') }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1">
                  <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
                </b-col>
                <b-col cols="10" offset-sm="1">
                  <span>
                    {{ $t('section-two.list.4') }}
                  </span>
                </b-col>
              </b-row>
               <b-row class="mt-5 d-flex justify-content-center">
                <base-button white outline @click="goToContactForm">{{ $t('colaborate-btn') }}</base-button>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>

      
<!-- 
      <b-row id="wellness" class="section-invert">
        <b-col md="12" lg="6">
          <div class="col-bg ml-lg-auto">
          </div>
        </b-col>
        <b-col md="12" lg="6" class="content my-auto">
          <h3>{{ $t('wellness.title') }}</h3>
          <div class="subtitle">
            <div class="subtitle-list subtitle-list-large mt-sm-5 pt-sm-5">
              <b-row>
                <b-col cols="1">
                  <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
                </b-col>
                <b-col cols="10" offset-sm="1">
                  <p>{{ $t('wellness.list.1.title') }}</p>
                  <span>
                    {{ $t('wellness.list.1.text') }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1">
                  <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
                </b-col>
                <b-col cols="10" offset-sm="1">
                  <p>{{ $t('wellness.list.2.title') }}</p>
                  <span>
                    {{ $t('wellness.list.2.text') }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1">
                  <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
                </b-col>
                <b-col cols="10" offset-sm="1">
                  <p>{{ $t('wellness.list.3.title') }}</p>
                  <span>
                    {{ $t('wellness.list.3.text') }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1">
                  <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
                </b-col>
                <b-col cols="10" offset-sm="1">
                  <p>{{ $t('wellness.list.4.title') }}</p>
                  <span>
                    {{ $t('wellness.list.4.text') }}
                  </span>
                </b-col>
              </b-row>
              <b-row class="mt-5">
                <base-button white outline @click="goToContactForm">{{ $t('more-information-btn') }}</base-button>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row> -->

      <opensalud4all-contact-form></opensalud4all-contact-form>
      <!-- <footer-opensalud></footer-opensalud> -->
    </div>
</template>

<script>
import { BCol, BTabs, BTab, BButton, BNavbar, BNavbarBrand, BNavbarToggle, BNavItem, BNavbarNav, BCollapse } from 'bootstrap-vue'
import BaseCard from '@/components/base/ui/BaseCard'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import FooterOpensalud from '@/components/public/footers/FooterOpensalud'
import LangSelector from '../../base/LangSelector.vue'
import Opensalud4allContactForm from '@/components/forms/Opensalud4allContactForm'
import es from '@/lang/es/public/views/opensalud4all.json'
import pt from '@/lang/pt/public/views/opensalud4all.json'
import en from '@/lang/en/public/views/opensalud4all.json'
import NeuCardsSlider2 from '@/components/base/ui/NeuCardsSlider2.vue'
import layoutMixin from '@/mixins/layout.mixin'

export default {
  mixins: [layoutMixin],
  components: {
    'base-dialog': () => import('@/components/base/BaseDialog'),
    'base-button': () => import('@/components/base/buttons/BaseButton'),
    'opensalud-discounts-business': () => import('@/components/views/opensalud/OpenSaludDiscountsBusiness.vue'),
    BCol,
    BTabs,
    BTab,
    BButton,
    BNavbar,
    BNavbarBrand,
    BNavbarNav,
    BNavbarToggle,
    BNavItem,
    BCollapse,
    BaseCard,
    Swiper,
    SwiperSlide,
    FooterOpensalud,
    LangSelector,
    Opensalud4allContactForm,
    NeuCardsSlider2
  },
  i18n: {
    messages: {
      es,
      en,
      mx: es,
      pt
    }
  },
  data () {
    /*eslint-disable */
    const medical_services = this.$t('discounts.medical-services-list').split('<br>')
    const teeth_services = this.$t('discounts.teeth-services-list').split('<br>')
    const health_services = this.$t('discounts.health-services-list').split('<br>')
    return {
      dialog1: false,
      dialog2: false,
      dialog3: false,
      medical_services: medical_services,
      langVisible: null,
      teeth_services: teeth_services,
      health_services: health_services,
      wellnessCards: [
        {
          title: this.$t('wellness-services.cards.1.title'),
          subtitle: this.$t('wellness-services.cards.1.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/yoga.svg'
        },
        {
          title: this.$t('wellness-services.cards.2.title'),
          subtitle: this.$t('wellness-services.cards.2.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/wellbeing-mindset.svg'
        },
        {
          title: this.$t('wellness-services.cards.3.title'),
          subtitle: this.$t('wellness-services.cards.3.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/environment-wellbeing.svg'
        },
        {
          title: this.$t('wellness-services.cards.4.title'),
          subtitle: this.$t('wellness-services.cards.4.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/social-wellbeing.svg'
        }
      ]
    }
  },
  directives: {
    swiper: directive
  },
  methods: {
    goToContactForm () {
      this.$router.push('opensalud4all-contacto')
    },
    goToMedicPsico () {
      this.goToSection('section-two', 1500)
    },
    getCookie: function (name) {
    var value = `; ${document.cookie}`
    var parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
  },
    goToSection (section, duration = 500) {
      this.$scrollTo(`#${section}`, duration, {
        container: 'body',
        easing: 'ease-in',
        lazy: false,
        force: true,
        cancelable: true,
        onStart: function (element) {
          // scrolling started
        },
        onDone: function (element) {
          // scrolling is done
        },
        onCancel () {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      })
    }
  },
  mounted () {
    this.langVisible = $cookies.get('langpref')
/*     let gtagScript = document.createElement('script')
    gtagScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=UA-73229352-1')
    document.head.appendChild(gtagScript)
    let gtagLocalScript = document.createElement('script')
    gtagLocalScript.setAttribute('src', '/static-appopensalud/gtag-opensalud360empresas.js')
    document.head.appendChild(gtagLocalScript)
    let gtagScript2 = document.createElement('script')
    gtagScript2.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-GYHPSFQW9K')
    document.head.appendChild(gtagScript2) */
  }
}
</script>

<style lang="scss" scoped>
  @import "static-appopensalud/css/public/views/opensalud4all.scss";
  @import "static-appopensalud/css/public/layout.scss";
    .center-text {
    text-align: center !important;
  }
  .navbar-mobile{
    padding-left: 1rem !important;
  }
  .btn-mobile{
    background-color: white !important;
    width: 4.5rem;
    font-size:0.8rem  !important;
    padding-left:0rem !important;
  }
.flex-mobile-lang {
  display:inline-flex !important;
}
.desktop-fix {
  @include desktop(){
    padding-top: 7rem !important;
    padding-left: 20rem !important;
    padding-right: 20rem !important;
  }
}
.carousel-inner {
  @include desktop(){
  width: 110% !important;
  right: 5% !important;

  }
}

.column_wrapper {
  column-count: 3;
}

.v-dialog--active .v-card__title {
  color: #3238C4;
  justify-content: center;
  word-break:break-word;
}
.v-dialog__content .v-dialog--active .v-card__text ul li {
  margin-top: 5px;
}
@media (max-width: 1268px) {
  #discounts > div.content.my-auto.col-md-12.col-lg-6 > div > div > div > p {
    font-size: 1rem;
  }
}
@media (max-width: 960px) {
  .v-dialog__content .v-dialog--active {
    width: 85vw;
  }
  .column_wrapper{
    column-count: 1;
  }
  #discounts .subtitle{
    width: 100%;
  }
}
@media (max-width: 960px) and (orientation: landscape) {
  .column_wrapper{
    column-count: 3;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/views/opensalud/Opensalud4all.vue